import React from 'react'
import { Button, Modal } from '@tecsinapse/cortex-react'
import { IoMdClose } from 'react-icons/io'
import { Trans } from '@lingui/react/macro'
import { useModalOverflowHidden } from '@/core/hooks/use-modal-overflow-hidden'
import {
  GrupoUsuariosEdicao,
  GrupoUsuariosEdicaoProps
} from '@/modules/grupo-usuarios-edicao/ui/grupo-usuarios-edicao'

interface GrupoUsuariosEdicaoDialogProps
  extends Omit<GrupoUsuariosEdicaoProps, 'isModal' | 'setAbrir'> {
  abrir: boolean
  setAbrir: React.Dispatch<React.SetStateAction<boolean>>
}

export const GrupoUsuariosEdicaoDialog = ({
  handleCloseDialog,
  abrir,
  setAbrir
}: GrupoUsuariosEdicaoDialogProps) => {
  useModalOverflowHidden({ open: abrir })
  const onClose = () => setAbrir?.(false)
  const onOpen = () => setAbrir?.(true)

  return (
    <Modal
      open={abrir}
      onClose={onClose}
      className={`flex flex-col w-[60%] overflow-y-scroll max-h-[80%]`}
    >
      <div className={'flex flex-row justify-between items-center mb-deca'}>
        <p className={'font-bold text-h3 text-center w-full'}>
          <Trans>Novo Grupo de Usuários</Trans>
        </p>
        <Button variants={{ size: 'square' }} onClick={onClose}>
          <IoMdClose />
        </Button>
      </div>
      <GrupoUsuariosEdicao
        handleCloseDialog={handleCloseDialog}
        onClose={onClose}
        onOpen={onOpen}
        isModal
      />
    </Modal>
  )
}
